<template>
  <v-container class="py-7">
    <v-row>
      <v-col cols="12">
        <div class="title-container">
          <div class="title-block">
            <span class="page-title">{{ pageTitle }}</span>
            <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbs"></v-breadcrumbs>
          </div>
          <div class="button-group">
            <v-btn color="primary" elevation="0" @click="save" :loading="loading" :disabled="form.is_system">Salvar</v-btn>
            <v-btn color="primary" outlined elevation="0" to="/cargos">Voltar</v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col cols="12">
          <v-card class="card-form-outlined">
            <v-card-title class="card-group-title">Detalhes</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="5">
                  <v-text-field dense label="Nome" v-model="form.name" :rules="[$rules.required]" outlined hide-details="auto" :disabled="form.is_system"></v-text-field>
                </v-col>
                <v-col cols="12" md="7">
                  <v-text-field dense label="Descrição" v-model="form.description" outlined hide-details="auto" :disabled="form.is_system"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card class="card-form-outlined">
            <v-card-title class="card-group-title">Permissões</v-card-title>
            <v-card-text>
              <v-alert v-if="form.is_system" type="info" text dense>
                Administrador geral possui todas as permissões e não pode ser alterado.
              </v-alert>

              <div v-for="group in catalog" :key="group.name" class="permission-group">
                <h3>{{ group.name }}</h3>

                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>Módulo</th>
                      <th v-for="method in methodHeaders" :key="method.method">{{ method.label }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="permission in group.permissions" :key="permission.path">
                      <td>{{ permission.label }}</td>
                      <td v-for="method in methodHeaders" :key="`${permission.path}-${method.method}`">
                        <v-checkbox
                          dense
                          hide-details
                          :disabled="form.is_system"
                          :input-value="hasPermission(permission.path, method.method)"
                          @change="togglePermission(permission.path, method.method, $event)"
                        ></v-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "RoleDetails",

  data: () => ({
    valid: true,
    loading: false,
    catalog: [],
    form: {
      name: "",
      description: "",
      permissions: [],
      is_system: false,
    },
  }),

  computed: {
    isNew() {
      return this.$route.params.id === "novo";
    },

    pageTitle() {
      return this.isNew ? "Novo cargo" : "Detalhes do cargo";
    },

    breadcrumbs() {
      return [
        { text: "Homepage", disabled: false, to: "/home", exact: true },
        { text: "Cargos e permissões", disabled: false, to: "/cargos", exact: true },
        { text: this.isNew ? "Incluir cargo" : "Detalhes do cargo", disabled: true, exact: true },
      ];
    },

    methodHeaders() {
      const first = this.catalog[0] && this.catalog[0].permissions[0];
      return first ? first.methods : [];
    },
  },

  async created() {
    await this.loadCatalog();
    await this.load();
  },

  methods: {
    async loadCatalog() {
      const result = await axios.get("/api/v1/roles/catalog");
      this.catalog = result.data.content || [];
    },

    async load() {
      if (this.isNew) return;

      this.loading = true;

      try {
        const result = await axios.get(`/api/v1/roles/${this.$route.params.id}`);
        const data = result.data.content;

        this.form = {
          name: data.name,
          description: data.description,
          is_system: data.is_system,
          permissions: (data.permissions || []).map((permission) => ({
            path: permission.path,
            method: permission.method,
          })),
        };
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 3000 });
      } finally {
        this.loading = false;
      }
    },

    hasPermission(path, method) {
      return this.form.permissions.some((permission) => permission.path === path && permission.method === method);
    },

    togglePermission(path, method, enabled) {
      if (enabled) {
        if (!this.hasPermission(path, method)) this.form.permissions.push({ path, method });
        return;
      }

      this.form.permissions = this.form.permissions.filter((permission) => !(permission.path === path && permission.method === method));
    },

    async save() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      try {
        const payload = {
          name: this.form.name,
          description: this.form.description,
          permissions: this.form.permissions,
        };

        if (this.isNew) await axios.post("/api/v1/roles", payload);
        else await axios.patch(`/api/v1/roles/${this.$route.params.id}`, payload);

        this.$dialog.notify.info("Cargo salvo com sucesso", { position: "top-right", timeout: 2000 });
        this.$router.push("/cargos");
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 3000 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.permission-group + .permission-group {
  margin-top: 24px;
}

.permission-group h3 {
  color: #17233f;
  font-size: 15px;
  font-weight: 800;
  margin: 0 0 10px;
}
</style>
